import { AlertTriangle, LogOut, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useAuthStore } from "@/stores/authStore";

export default function NoPermissionGroupPage() {
  const { user, logout } = useAuthStore();

  const handleLogout = async () => {
    await logout();
    window.location.href = "/login";
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-4 text-center">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-orange-100">
            <AlertTriangle className="h-8 w-8 text-orange-600" />
          </div>
          <div>
            <CardTitle className="text-2xl">권한이 설정되지 않았습니다</CardTitle>
            <CardDescription className="mt-2">
              관리자가 아직 권한 그룹을 지정하지 않았습니다
            </CardDescription>
          </div>
        </CardHeader>

        <CardContent className="space-y-6">
          <div className="space-y-4 rounded-lg bg-orange-50 p-4 text-sm">
            <div className="space-y-2">
              <p className="font-medium text-orange-900">권한 그룹이 설정되지 않은 이유:</p>
              <ul className="list-inside list-disc space-y-1 text-orange-700">
                <li>계정이 최근에 생성되어 권한 그룹이 아직 할당되지 않았습니다</li>
                <li>관리자가 권한 설정을 완료하지 않았습니다</li>
                <li>시스템 설정 중 오류가 발생했을 수 있습니다</li>
              </ul>
            </div>
          </div>

          {user && (
            <div className="space-y-2 rounded-lg border bg-muted/50 p-4 text-sm">
              <p className="font-medium">계정 정보</p>
              <div className="space-y-1 text-muted-foreground">
                <p>이름: {user.name}</p>
                <p>이메일: {user.email}</p>
                <p>사용자 구분: {
                  user.user_type === "employee" ? "직원" :
                  user.user_type === "external_staff" ? "외부직원" :
                  user.user_type === "customer" ? "고객" : "기타"
                }</p>
              </div>
            </div>
          )}

          <div className="space-y-3">
            <div className="flex items-start gap-2 text-sm text-muted-foreground">
              <Mail className="mt-0.5 h-4 w-4 flex-shrink-0" />
              <p>
                관리자에게 연락하여 권한 그룹을 설정해 달라고 요청하세요.
                권한 그룹이 설정되면 시스템을 정상적으로 사용할 수 있습니다.
              </p>
            </div>
          </div>

          <Button
            onClick={handleLogout}
            variant="outline"
            className="w-full"
          >
            <LogOut className="mr-2 h-4 w-4" />
            로그아웃
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
